Bingo.SectionEditing = {};
Bingo.SectionEditing.updateBody = function () {
    if ($('.section-editing-active').length > 0) {
        $('body').addClass('section-editing-active');
    } else {
        $('body').removeClass('section-editing-active');
    }
    Bingo.DatagridDragging.init();
};
Bingo.SectionEditing.contactBoxSuccess = function () {
    $('.js-contactOwnerContainer').removeClass('section-editing-active');
    $('body').removeClass('modal-section-editing-active');
    // GTM email sent event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'Contact-Email-Success'});
};
